import { render, staticRenderFns } from "./FeesList.vue?vue&type=template&id=2d388e62&"
import script from "./FeesList.vue?vue&type=script&lang=js&"
export * from "./FeesList.vue?vue&type=script&lang=js&"
import style0 from "./FeesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports